<template><div>
    <slot><div>Название поля</div></slot>
    <div class="myni">
        <div class="nights-field" @click.stop="toggle">
            <vDays class="ico-days vicon-black" />
            <div class="label" :class="{empty: days_text == props.placeholder}" >{{days_text}}</div>
            <button v-if="!isAny" class="clear" @click.stop="setday(0,DAYS_MAX)"><vRemove class="vicon-red" /></button>
        </div>
        <div class="nights-popup" v-if="isOpened" ref="oknoRef">
            <div class="nights-popup__content">

                <label class="g" v-for="({a,b,title}) in MANUAL" :key="`${a}${b}`">
                    <input class="rb" name="rb-manual"  type="radio" v-model="manual_calc" :value="[a,b]" />
                    <span class="title">{{title}}</span>
                </label>

                <label class="gcust">
                    <input class="rb" name="rb-manual" type="radio" v-model="manual_calc" :value="MANUAL_CUST_AB" />
                    <span class="line">
                        <select class="sele sele0" :class="{red:!cust_valid()}" v-model="cust_a">
                            <option v-for="option in opt_cust0" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>

                        -

                        <select class="sele sele1" :class="{red:!cust_valid()}" v-model="cust_b">
                            <option v-for="option in opt_cust1" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>

                        дней
                    </span>
                </label>


            </div>
            
        </div>
    </div>

</div></template>

<style lang="scss" src="./MyNights.scss"></style>


<script setup>
import {ref, computed, unref, onBeforeUnmount, onMounted} from 'vue'
import { numWord } from '@/util.js'
import vRemove from '@/assets/vicons/remove.vue'
import vDays from '@/assets/vicons/how-many-days2.vue'

const props = defineProps({
  choosed: Array,
  placeholder: {type: String, default: 'выбрать'},
})
const emits = defineEmits([ 'input' ])

const DAYS_MAX = 30
const MANUAL = [
    {a:0, b:DAYS_MAX, title: 'любая'},
/*  {a:0, b:4, title: '1 - 4 дня'},
    {a:5, b:7, title: '5 - 7 дней'},
    {a:8, b:14, title: '8 - 14 дней'},
    {a:5, b:DAYS_MAX, title: 'от 15 дней'},
*/
]
const MANUAL_CUST_AB=[-1,0]

const oknoRef = ref(null)
const isOpen = ref(false) // false будет
const cust = ref([1,DAYS_MAX]) 

const last_clicked = ref([-1,-1]) // не должно ни с чем совпадать

const opt_cust0 = Array.from({length:31}).map( 
    (_,ind) => {
        return {id:ind, name: `${ind}`}
    }
)
const opt_cust1 = Array.from({length:30}).map(
    (_,ind) => {
        return {id:ind+1, name: `${ind+1}`}
    }
)


/*************************************************
* логика окошечка
*/

const isOpened = computed({
    get() {
        return isOpen.value
    },
    set(nov) {
        let isNew = isOpen.value != nov
        isOpen.value = nov
        if (isNew) {
            processCloseEvents( nov )
        }
        if (nov) {
            cust.value = isAny.value ? [2,3] : vals.value
            last_clicked.value = [-1,-1]
        }
    },
})


const inspectCloseEvent = (event) => {
    let el = unref(oknoRef)
    if (event.keyCode) {
        event.keyCode === 27 && close()
    } else if (el && !(event.target === el) && !el.contains(event.target)) {
        close()
    }
}

const processCloseEvents = (opened) => {
    if (opened) {
        ['click', 'keyup', 'focusin'].forEach(
            eventName => document.addEventListener(eventName, inspectCloseEvent)
        );
    } else {
        ['click', 'keyup', 'focusin'].forEach(
            eventName => document.removeEventListener(eventName, inspectCloseEvent)
        );
    }
}

const toggle = () => {
    isOpened.value = !isOpened.value
}
const close = () => {
    isOpened.value = false
}

onBeforeUnmount( close )

/*************************************************
* обрабатываем ввод
*/

const setday_close = (a,b) => {
    setday(a,b)
    close()
}

const setday = (a,b) => {
    let a1 = day2ni(a, false)
    let b1 = day2ni(b, true)
    let inp = [a1, b1]
    if (!arraysEqual(props.choosed, inp)) {// защита от спама
        emits('input', [a1, b1] )
    }
}

const days_text_func = (ain,b) => {
    let ret = ''

    let a = Math.max(ain,1)
    if (1===a && DAYS_MAX === b) {
        ret = props.placeholder
    } else if (a === b) {
        ret = `${numWord(a)}`
    } else {
        ret = `${a} — ${numWord(b)}`
    }
    return ret
}

const days_text = computed( ()=> {
    let [a,b] = vals.value
    return days_text_func(a,b)
})

const isAny = computed( () => {
    let [a,b] = vals.value
    return 0===a && DAYS_MAX === b
})


const vals = computed( () => {
    let [a,b] = props.choosed
    let a1 = ni2day( a , false )
    let b1 = ni2day( b , true )

    return [ a1, b1 ]
})


const manual_calc = computed({
  get() {
    let [a,b] = vals.value
    let ret
    if (MANUAL.find( ob => ob.a === a && ob.b === b  )) {
        ret = [a,b]
        if (arraysEqual(last_clicked.value, MANUAL_CUST_AB)) {
            ret = MANUAL_CUST_AB
        }
    } else {
        ret = MANUAL_CUST_AB
    }
    return ret
  },
  set(value) {
    let [a,b] = value
    last_clicked.value = [a,b]
    if (!arraysEqual([a,b], MANUAL_CUST_AB)) {
        setday(a,b)
        if (!arraysEqual([a,b], [0, DAYS_MAX])) {
            cust.value = [a,b]
        }
    } else {
        on_cust_change()
    }
  }
})

const cust_a = computed({
    get() {
        let [a,b] =  cust.value
        return a
    },
    set(v) {
//        v = parseInt(v, 10)
        let [a,b] = unref(cust)
        cust.value = [v ,b ]
        last_clicked.value = MANUAL_CUST_AB
        on_cust_change()
    }
})
const cust_b = computed({
    get() {
        let [a,b] = cust.value
        return b
    },
    set(v) {
//        v = parseInt(v, 10)
        let [a,b] = unref(cust)
        cust.value = [ a, v ]
        last_clicked.value = MANUAL_CUST_AB
        on_cust_change()
    }
})

const cust_valid = () => {
    let [a,b] = cust.value
    return a<=b ? true : false
}

const on_cust_change = () => {
    let [a,b] = cust.value
    if (a<=b) {
        setday(a,b)
    }
}
 
const arraysEqual = (a, b) =>
  a.length === b.length &&
  a.every((val, i) => val === b[i])

const ni2day = (n, isB) => {
    let day = 0
    if (""===n) {
        day = isB ? DAYS_MAX : 0
    } else {
        let ni = parseInt( n, 10)
        day = ni+1 >= DAYS_MAX ? DAYS_MAX : ni+1
    }
    return day
}

const day2ni = (day, isB) => {
    let ni = ""
    if (day<=1) {
        ni = isB ? '1' : ''
    }else if (day >= DAYS_MAX) {
        ni = isB ? '' : (day - 1).toString()
    } else {
        ni = (day - 1).toString() 
    }
    return ni
}


</script>

